<template>
  <div class="fd-dbjg-content">
    <MyTitle theTitle="担保机构" />
    <ul class="fd-com-tab">
      <li
        class="fd-item"
        :class="{'fd-active': item.key === currentTab }"
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeTab(item.key)">
        {{ item.name }}
      </li>
    </ul>
    <div class="fd-dbjg-list fd-com-scroll">
      <div
        class="fd-dbjg-li"
        v-for="(item, index) in BxgsList"
        :key="index">
        <div class="fd-choose">
          <van-radio-group v-model="cBxgs">
            <van-radio :name="item.bxgs" @click="changeBxgs(item)"></van-radio>
          </van-radio-group>
          <!--                        <el-radio v-model="chooseDbjgCode" :label="item.bxgs" @input="changeSelect(item)"></el-radio>-->
        </div>
        <div class="fd-con">
          <div class="dbjg-logo">
            <!--                        <span class="logo" :style="{'background-image':'url(' + item.logoUrl||null + ')'}"></span>-->
            {{ item.bxgsName }}
          </div>
          <van-row>
            <van-col
              span="8"
              class="dbjg-li"
              :class="{ hightlight: currentTab === '7' }"
            >
              预估保费:<span v-text="item.ygPremium"></span>元
            </van-col>
            <van-col span="8" class="dbjg-li">
              出函速度:<span v-text="item.avgRate"></span>小时
            </van-col>
            <van-col
              span="8"
              class="dbjg-li"
              :class="{ hightlight: currentTab === '5' }"
            >
              服务评分:<span v-text="item.avgSerScoreRankScore"></span>分
            </van-col>
          </van-row>
          <van-row>
            <van-col
              span="8"
              class="dbjg-li"
              :class="{ hightlight: currentTab === '3' }"
            >
              月销量:<span v-text="item.monthSales"></span>件
            </van-col>
            <van-col
              span="8"
              class="dbjg-li"
              :class="{ hightlight: currentTab === '6' }"
            >
              综合评分:<span v-text="item.compreScore"></span>分
            </van-col>
          </van-row>
          <van-row>
            <van-col span="24" class="dbjg-li">
              联系电话:<span v-text="item.cPhone"></span>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="fd-com-btn-container">
      <van-button
        type="info"
        round
        plain
        :disabled="!cBxgs"
        @click="addDbjgAndReturn"
      >
        确定
      </van-button>
    </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { mapGetters } from "vuex";
import { Notify } from "vant";

export default {
  data() {
    return {
      currentTab: "6",
      tabList: [
        {
          key: "6",
          name: "综合评分",
        },
        {
          key: "7",
          name: "低价优先",
        },
        {
          key: "3",
          name: "销量优先",
        },
        {
          key: "5",
          name: "好评优先",
        },
      ],
      cBxgs: "",
      cBxgsmc: "",
      BxgsList: [],
    };
  },
  computed: {
    ...mapGetters([
      "codeList_105000",
      "codeList_108000",
      "codeList_110000",
      "codeList_120000",
      "codeList_109000",
    ]),
  },
  components: {
    MyTitle,
  },
  methods: {
    // 切换tab
    changeTab(key) {
      this.currentTab = key;
      this.getDbjgList();
    },
    changeBxgs(prop) {
      this.cBxgs = prop.bxgs;
      this.cBxgsmc = prop.bxgsName;
    },
    // 初始化
    init() {
      this.getDbjgList();
    },
    // 请求保险机构
    getDbjgList() {
      return this.$axios
        .get(
          "ssbq/api/dbjg/rankingDetail?rankLx=" +
            this.currentTab +
            "&dbid=" +
            JSON.parse(sessionStorage.getItem("currentDbid"))
        )
        .then((res) => {
          this.BxgsList = res.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 保存保险机构
    addDbjgAndReturn() {
      const queryData = {
        cId: JSON.parse(sessionStorage.getItem("currentDbid")),
        cBxgs: this.cBxgs,
        cBxgsmc: this.cBxgsmc,
      };
      return this.$axios
        .post("ssbq/api/ssdb/updatedbjbxx", queryData)
        .then((res) => {
          if (res.code === 200) {
            this.$router.push("/guaranteeInfo");
          } else {
            Notify({
              message: res.message,
              type: "danger",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    this.cBxgs = sessionStorage.getItem("BxgsId");
    this.cBxgsmc = sessionStorage.getItem("Bxgsmc");
    this.init();
  },
};
</script>

<style lang="less" scoped>
.fd-dbjg-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.fd-dbjg-list {
  padding: 0 20px;
  width: 100%;
  overflow-y: scroll;

  .fd-dbjg-li {
    padding: 5px 0;
    display: flex;
    border-bottom: 1px solid #f5f5f5;

    .fd-choose {
      padding-top: 3px;
      padding-right: 10px;
    }

    .fd-con {
      flex-grow: 1;
    }

    .dbjg-logo {
      font-size: 14px;
      line-height: 24px;

      .logo {
        margin-right: 20px;
        display: inline-block;
        width: 160px;
        height: 74px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
    }

    .dbjg-li {
      padding: 5px 10px 5px 0;
    }

    .hightlight {
      &.dbjg-li {
        span {
          color: red;
        }
      }
    }
  }
}

.fd-dbjg-tab {
  margin: 10px 20px;
  display: flex;
  font-size: 15px;

  li {
    margin-right: 20px;
    line-height: 36px;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    font-size: 15px;
    color: #2c3542;
    &.current {
      font-size: 15px;
      color: #2c3542;
      font-weight: 600;
      font-family: "PingFangSC-Semibold";
      border-color: #0096ff;
    }
  }
}
</style>
